// extracted by mini-css-extract-plugin
export default {"page":"Ah-z","cartModal":"Bh-z","checkout":"Ch-z","placeholder":"Dh-z","account":"Eh-z"};